"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileStatus = exports.LinkEmbedType = exports.ImageFit = exports.ProgrammingLanguage = exports.TextType = exports.ImageTagType = exports.BlockType = void 0;
/* -------------------------------------------------- */
/*                    Block Types                     */
/* -------------------------------------------------- */
var BlockType;
(function (BlockType) {
    BlockType["Text"] = "text";
    BlockType["Code"] = "code";
    BlockType["Color"] = "color";
    BlockType["Image"] = "image";
    BlockType["Link"] = "linkEmbed";
    BlockType["File"] = "file";
    BlockType["BlockWindow"] = "blockWindow";
    BlockType["PlateWindow"] = "pageWindow";
})(BlockType = exports.BlockType || (exports.BlockType = {}));
/* -------------------------------------------------- */
/*                    Helper Enums                    */
/* -------------------------------------------------- */
var ImageTagType;
(function (ImageTagType) {
    ImageTagType[ImageTagType["Custom"] = 0] = "Custom";
    ImageTagType[ImageTagType["Generated"] = 1] = "Generated";
})(ImageTagType = exports.ImageTagType || (exports.ImageTagType = {}));
var TextType;
(function (TextType) {
    TextType["Plain"] = "plain";
    TextType["Quote"] = "quote";
    TextType["Mono"] = "monospace";
    TextType["H1"] = "headerOne";
    TextType["H2"] = "headerTwo";
})(TextType = exports.TextType || (exports.TextType = {}));
var ProgrammingLanguage;
(function (ProgrammingLanguage) {
    ProgrammingLanguage["Javascript"] = "Javascript";
    ProgrammingLanguage["Java"] = "Java";
    ProgrammingLanguage["Typescript"] = "Typescript";
    ProgrammingLanguage["Markup"] = "Markup";
    ProgrammingLanguage["Python"] = "Python";
    ProgrammingLanguage["Hoon"] = "Hoon";
    ProgrammingLanguage["LaTeX"] = "LaTeX";
    ProgrammingLanguage["C"] = "C";
    ProgrammingLanguage["CPP"] = "CPP";
    ProgrammingLanguage["HCL"] = "HCL";
    ProgrammingLanguage["R"] = "R";
    ProgrammingLanguage["OCaml"] = "OCaml";
    ProgrammingLanguage["SQL"] = "SQL";
    ProgrammingLanguage["Markdown"] = "Markdown";
    ProgrammingLanguage["JSON"] = "JSON";
    ProgrammingLanguage["HTML"] = "HTML";
    ProgrammingLanguage["CSS"] = "CSS";
    ProgrammingLanguage["JSX"] = "JSX";
    ProgrammingLanguage["Bash"] = "Bash";
    ProgrammingLanguage["Go"] = "Go";
    ProgrammingLanguage["Swift"] = "Swift";
    ProgrammingLanguage["Rust"] = "Rust";
})(ProgrammingLanguage = exports.ProgrammingLanguage || (exports.ProgrammingLanguage = {}));
var ImageFit;
(function (ImageFit) {
    ImageFit["Cover"] = "cover";
    ImageFit["Contain"] = "contain";
})(ImageFit = exports.ImageFit || (exports.ImageFit = {}));
var LinkEmbedType;
(function (LinkEmbedType) {
    LinkEmbedType["Spotify"] = "spotifyEmbed";
    LinkEmbedType["Twitter"] = "twitterEmbed";
    LinkEmbedType["Youtube"] = "youtubeEmbed";
    LinkEmbedType["Instagram"] = "instagramEmbed";
    LinkEmbedType["Other"] = "linkEmbed";
})(LinkEmbedType = exports.LinkEmbedType || (exports.LinkEmbedType = {}));
var FileStatus;
(function (FileStatus) {
    FileStatus["Uploading"] = "UPLOADING";
    FileStatus["Uploaded"] = "UPLOADED";
    FileStatus["Failed"] = "FAILED";
    FileStatus["None"] = "NONE";
})(FileStatus = exports.FileStatus || (exports.FileStatus = {}));
//# sourceMappingURL=block-snapshot.entity.js.map